import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from "jquery/dist/jquery";
import * as M from "materialize-css/dist/js/materialize";

import { ResourcesService } from '../resources.service';

@Component({
    selector: 'app-lotes',
    templateUrl: './lotes.component.html',
    styleUrls: ['./lotes.component.css']
})
export class LotesComponent implements OnInit {

    lotes : any = [];
    user : any = {};
    idgalpon : string;
    title : string = '';
    isConnected = true;
    instance: any;
    wifi = 'wifi';

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        public resource: ResourcesService,
        private _location: Location
    ) {

        let user = localStorage.getItem('user')
        this.user = JSON.parse(user);
        if (user == undefined) {
            this.router.navigate(['/']);
            return
        } else {
            this.route.paramMap.subscribe(params => {
                this.idgalpon = params.get('idgalpon');
                if (this.idgalpon == null) {
                    var url = resource.route+'/lotes';
                    this.title = "Lotes"
                } else {
                    var url = resource.route+'/lotes/'+this.idgalpon;
                }
                this.http.get(url).subscribe(
                    async (data: any) => {
                        if (data.length > 0) {
                            for (let i = 0; i < data.length; i++) {
                                if (data[i]['FecinicioProd'] == '0000-00-00 00:00:00') {
                                    data[i]['FecinicioProd'] = '2020-01-12T23:00:00.000Z'
                                }
                            }
                            if (this.idgalpon != null) {
                                this.title = "Galpón "+data[0].Galpon
                            }

                            if(this.user.TipoPesaje == 2){
                                this.lotes = [];
                                for (let i = 0; i < data.length; i++) {
                                    const d = data[i];
                                    if(d.Sexo == 'H'){
                                        this.lotes.push(d)
                                    }
                                }
                                this.lotes = this.lotes.reverse();
                            }else{
                                this.lotes = data.reverse();
                            }
                            
                            // if(this.resource.falta_subir.length != 0){
                            //     await this.confirm();
                            // }
                            await resource.updateLocalStorageFromOnline()
                        }
                    },error => {
                        console.log('errorx lotes online', error)
                        var lotes = localStorage.getItem('lotes')
                        lotes = JSON.parse(lotes)
                        console.log('lotes online', lotes)
                        for (let i = 0; i < lotes.length; i++) {
                            if(this.user.TipoPesaje == 2){
                                if (lotes[i]['idGalpon'] == this.idgalpon) {
                                    if(lotes[i]['Sexo'] == 'H'){
                                        this.lotes.push(lotes[i])
                                        this.title = lotes[i]['Galpon']
                                    }
                                }
                            }else{
                                if (lotes[i]['idGalpon'] == this.idgalpon) {
                                    this.lotes.push(lotes[i])
                                    this.title = lotes[i]['Galpon']
                                }
                            }
                        }
                        this.lotes = this.lotes.reverse();
                    }
                );
            });
        }
    }

    ngOnInit(): void {
    }

    goToCorral(idLote) {
        this.router.navigateByUrl('/corrales/'+idLote);
    }

    regresar() {
        this.router.navigate(['/galpones/']);
    }

    confirm() {
        var elem = document.getElementById('modalSincronizacionLocalServidor');
        this.instance = M.Modal.init(elem);
        this.instance.open();
    }

}
